import { render, staticRenderFns } from "./ExtFooter.vue?vue&type=template&id=3e27548b&"
import script from "./ExtFooter.vue?vue&type=script&lang=ts&"
export * from "./ExtFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ExtFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports